export default __webpack_public_path__ + "static/media/141.6488516d.png";